import "./postagem.css";
import { useState } from "react";
import api from "../../constants/api.js";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function Postagem({
  post,
  tipo,
  abrirPost,
  editarPost,
  excluirPost,
  atualizarPost
}) {
  const [ativo, setAtivo] = useState(post.ativo);
  const [ordem, setOrdem] = useState(post.ordem ?? "");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ✅ agora posts E matérias
  const temControleEditorial =
    tipo === "post" || tipo === "materia";

  const id =
    tipo === "post" ? post.id_post : post.id_materia;

  const rotaConfig =
    tipo === "post"
      ? `/posts/${id}/config`
      : `/materias/${id}/config`;

  async function toggleAtivo() {
    if (!temControleEditorial) return;

    try {
      setLoading(true);

      await api.patch(rotaConfig, {
        ativo: !ativo,
      });

      setAtivo(!ativo);
      atualizarPost?.(id, { ativo: !ativo });
    } catch {
      Swal.fire("Erro", "Não foi possível alterar status", "error");
    } finally {
      setLoading(false);
    }
  }

  async function salvarOrdem() {
  if (!temControleEditorial) return;

  if (!ativo) {
    Swal.fire({
      icon: "info",
      title: "Ative a matéria",
      text: "Só é possível definir ordem para matérias ativas"
    });
    return;
  }

  try {
    setLoading(true);

    const valor = ordem === "" ? null : Number(ordem);

    await api.patch(rotaConfig, {
      ordem: valor,
    });

    atualizarPost?.(id, { ordem: valor });

    Swal.fire({
      icon: "success",
      title: "Ordem salva",
      timer: 1000,
      showConfirmButton: false,
    });
  } catch (error) {
    Swal.fire(
      "Erro",
      error.response?.data?.error || "Erro ao salvar ordem",
      "error"
    );
  } finally {
    setLoading(false);
  }
}


  return (
    <div className={`post-card ${ativo === false ? "post-inativo" : ""}`}>
      {post.imagem_url && (
        <img
          src={post.imagem_url}
          alt={post.titulo}
          className="post-img"
          onError={(e) => (e.target.style.display = "none")}
        />
      )}

      <div className="post-content">
        {temControleEditorial && (
          <span className={ativo ? "badge-ativo" : "badge-inativo"}>
            {ativo ? "ATIVO" : "INATIVO"}
          </span>
        )}

        <h3>{post.titulo}</h3>
        <p>{post.texto?.slice(0, 120)}...</p>
      </div>

      {temControleEditorial && (
        <div className="post-editorial">
          <button
            onClick={toggleAtivo}
            disabled={loading}
            className={ativo ? "btn-desativar" : "btn-ativar"}
          >
            {ativo ? "Desativar" : "Ativar"}
          </button>

          <div className="ordem-box">
            <input
              type="number"
              min="1"
              max="10"
              placeholder="Ordem"
              value={ordem}
              onChange={(e) => setOrdem(e.target.value)}
            />
            <button onClick={salvarOrdem} disabled={loading}>
              Salvar
            </button>
          </div>
        </div>
      )}

      <div className="post-actions">
        <button onClick={() => abrirPost(id)}>Ver</button>
        <button onClick={() => editarPost(post)}>Editar</button>
        

        <button
          className="btn-excluir"
          onClick={() => excluirPost(id)}
        >
          Excluir
        </button>
      </div>
    </div>
  );
}

export default Postagem;
